export function gEventsTrigger (gEvents, inputName) {
  return { ...gEvents[inputName], trigger: 'click' }
}
